import React from 'react';
import { Colors } from 'works/legacy/lib/style-helper';
import { InputNumber } from 'antd';

export const PercentInput = (
  props: React.ComponentProps<typeof InputNumber>
) => (
  <>
    <div className="percent-input">
      <InputNumber {...props} min={0} />
    </div>
    <style jsx>{`
      .percent-input {
        position: relative;
      }

      .percent-input :global(.ant-input-number::before) {
        content: '%';
        position: absolute;
        top: 3px;
        right: 8px;
        line-height: 24px;
        color: ${Colors.midnightLighter};
      }

      .percent-input :global(input) {
        padding-right: 25px;
        text-align: right;
      }

      .percent-input :global(.ant-input-number) {
        width: 100%;
      }

      .percent-input :global(.ant-input-number-handler-wrap) {
        display: none;
      }
    `}</style>
  </>
);
